import {
  Table,
  TableBody,
  TablePagination,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../shared/state/root-reducer";
import { patientSearchResult } from "../../../admissions-advisor/models/patient";
import { usePatientSearch } from "../../../shared/patient-search/usePatientSearch";

import OpenSearchModal from "../../../patient/components/patient-overview/open-search-modal";
import OpenSearchInput from "../../../patient/components/patient-overview/open-search-input";
import EstimatesPatientRow from "./estimates-patient-row";

interface EstimatesSearchModalProps {
  renderSearchPatient?: ((openOnClick: () => void) => React.ReactNode) | null
  onClickConfig?: {
    patient: (patientId: number) => void
    ioc: (patientId: number, encounterId: number) => void
    vob: (patientId: number) => void
    estimate: (patientId: number, encounterId?: number) => void
  }
}

export function EstimatesSearchModal(props: EstimatesSearchModalProps) {

  const {
    renderSearchPatient = null,
    onClickConfig
  } = props

  const [patientIdToOpen, setPatientIdToOpen] = useState("");

  const {
    inputValue,
    setInputValue,
    patientsList,
    patientsCount,
    isLoading,
    page,
    rowsPerPage,
    handlePageChange,
    handleChangeRowsPerPage,
    reset,
  } = usePatientSearch({ paramId: -2, debounceMs: 750 });

  const isLoadingFacilities = useSelector(
    (state: RootState) =>
      state.implementationContext.implementationFacility.isLoading
  );
  const isLoadingFacilityLocPayers = useSelector(
    (state: RootState) =>
      state.admissionsAdvisorContext.vobContext.isLoading
        .isLoadingFacilityLocPayers
  );
  const allClients = useSelector(
    (state: RootState) =>
      state.implementationContext?.implementationSpecialistClient
        .allClientsWithFacillities
  );
  const allClientsMap = useSelector(
    (state: RootState) =>
      state.implementationContext?.implementationSpecialistClient
        .allClientsWithFacilitiesMap
  );

  const handleExpandPatientTable = (documentId: string) => {
    if (patientIdToOpen === documentId) {
      setPatientIdToOpen("");
    } else {
      setPatientIdToOpen(documentId);
    }
  };

  const resetState = () => {
    setPatientIdToOpen("");
    reset();
  };

  return (
    <OpenSearchModal
      resetState={resetState}
      actionButton={null}
      renderSearchPatient={renderSearchPatient}
    >
      <OpenSearchInput
        inputValue={inputValue}
        isLoading={isLoading}
        handleInputChange={(e) => setInputValue(e.target.value)}
      />
      {patientsList.length > 0 && (
        <>
          <Table size="small" sx={{ marginTop: "10px" }}>
            <TableBody>
              {patientsList.map((patient: patientSearchResult) => (
                <EstimatesPatientRow
                  key={patient._id}
                  patient={patient}
                  patientIdToOpen={patientIdToOpen}
                  handleExpandPatientTable={handleExpandPatientTable}
                  handleModalClose={resetState}
                  allClients={allClients}
                  allClientsMap={allClientsMap}
                  isLoadingFacilities={isLoadingFacilities}
                  isLoadingFacilityLocPayers={isLoadingFacilityLocPayers}
                  onClickConfig={onClickConfig}
                />
              ))}
            </TableBody>
          </Table>
          {patientsCount > 0 && (
            <TablePagination
              component="div"
              onPageChange={handlePageChange}
              page={page}
              count={patientsCount}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </>
      )}
      {patientsList.length === 0 &&
        !isLoading &&
        inputValue.length > 2 && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <b>No Matching Results To Show</b>
          </div>
        )}
    </OpenSearchModal>
  );
}
